import { render, staticRenderFns } from "./Modification.vue?vue&type=template&id=acc06486&scoped=true"
import script from "./Modification.vue?vue&type=script&lang=js"
export * from "./Modification.vue?vue&type=script&lang=js"
import style0 from "./Modification.vue?vue&type=style&index=0&id=acc06486&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "acc06486",
  null
  
)

export default component.exports